import AuthGuest from "../AuthGuest"
import { API_PUBLIC } from "@/app/contants/url"

const BlogService = {
  getList: (params: any): AwaitStatusResponse<any> => AuthGuest().get(`${API_PUBLIC}blog`, {params}),
  getDetails: (slug: string): AwaitStatusResponse<any> => AuthGuest().get(`${API_PUBLIC}blog/${slug}`),
  getCategories: (params: any): AwaitStatusResponse<any> => AuthGuest().get(`${API_PUBLIC}blog/category`, {params}),
}
export default BlogService
